import { Country } from '@sr/types';

export const getPrivacyPolicyLink = (market: Country | null | undefined): string => {
  if (!market) {
    return 'https://www.stenarecycling.com/sv/privacy/';
  }

  switch (market) {
    case Country.DENMARK:
      return 'https://www.stenarecycling.com/da/privacy/';
    case Country.NORWAY:
      return 'https://www.stenarecycling.com/no/privacy/';
    case Country.SWEDEN:
      return 'https://www.stenarecycling.com/sv/privacy/';
    default:
      return 'https://www.stenarecycling.com/sv/privacy/';
  }
};

export const getWaiverLink = (
  subscriptionType: 'CO2' | 'CSRD_PREMIUM',
  market: Country | null | undefined,
  s3AssetsUrl: string,
): string => {
  if (subscriptionType === 'CO2') {
    if (market === Country.DENMARK) {
      return `${s3AssetsUrl}/subscriptions/WAIVER_CO2_Impact_DK_EN.pdf`;
    }

    if (market === Country.NORWAY) {
      return `${s3AssetsUrl}/subscriptions/WAIVER_CO2_Impact_NO_EN.pdf`;
    }

    return `${s3AssetsUrl}/subscriptions/WAIVER_CO2_Impact.pdf`;
  }

  // CSRD Premium
  if (!market) {
    return `${s3AssetsUrl}/csrd/se/WAIVER_CSRD_ESRS_E5_SE_EN.pdf`;
  }

  switch (market) {
    case Country.DENMARK:
      return `${s3AssetsUrl}/csrd/dk/WAIVER_CSRD_ESRS_E5_DK_EN.pdf`;
    case Country.NORWAY:
      return `${s3AssetsUrl}/csrd/no/WAIVER_CSRD_ESRS_E5_NO_EN.pdf`;
    case Country.SWEDEN:
      return `${s3AssetsUrl}/csrd/se/WAIVER_CSRD_ESRS_E5_SE_EN.pdf`;
    default:
      return `${s3AssetsUrl}/csrd/se/WAIVER_CSRD_ESRS_E5_SE_EN.pdf`;
  }
};

export const getGeneralTermsAndConditionsLink = (market: Country | null | undefined): string => {
  if (market === Country.NORWAY) {
    return 'https://www.stenarecycling.com/siteassets/about-us/documents/standardvilkar-stena-recycling-as-versjon-mars-2021.pdf';
  }

  return 'https://www.stenarecycling.com/siteassets/about-us/documents/general-terms-and-conditions1.pdf';
};
